import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52261cd2")

_pushScopeId("data-v-52261cd2")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = {
  key: 0,
  class: "page__error"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "icon-team" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", null, "Aucune équipe ne correspond au nom recherché")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "team__content"
}
const _hoisted_7 = { class: "team__group team--info scrollbar--invisible" }
const _hoisted_8 = { class: "team__summary" }
const _hoisted_9 = { class: "team__title--wrapper" }
const _hoisted_10 = { class: "item__title" }
const _hoisted_11 = { class: "item__subtitle" }
const _hoisted_12 = { class: "team__logo" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-sketch" }, null, -1)
const _hoisted_14 = { class: "team__stats" }
const _hoisted_15 = { class: "team__group team--results" }
const _hoisted_16 = {
  key: 0,
  class: "team__image--wrapper"
}
const _hoisted_17 = { class: "tabs" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "icon-calendar" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "tab__text" }, "Calendrier", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "icon-role" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "tab__text" }, "Joueurs", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "icon-camera" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "tab__text" }, "Social", -1)
const _hoisted_24 = { class: "item team--data" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_TheTeamStats = _resolveComponent("TheTeamStats")
  const _component_TheScheduleTable = _resolveComponent("TheScheduleTable")
  const _component_TheTeamPlayers = _resolveComponent("TheTeamPlayers")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (!_ctx.teamExists)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_TeamLabel, {
                      team: _ctx.team,
                      teamName: true,
                      badge: true,
                      link: false
                    }, null, 8, ["team"])
                  ]),
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.divisionDisplay), 1)
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_TeamLabel, {
                    team: _ctx.team,
                    teamName: false,
                    link: false
                  }, null, 8, ["team"]),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        id: "edit-team",
                        class: "button button--action",
                        title: "Modifier l'équipe",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editTeam && _ctx.editTeam(...args)), ["stop"]))
                      }, [
                        _hoisted_13
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_TheTeamStats, {
                  teamName: _ctx.team.name
                }, null, 8, ["teamName"])
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              (_ctx.tabSelected !== _ctx.TAB_TYPES.SOCIAL && _ctx.hasPicture && _ctx.teamImageVisible)
                ? (_openBlock(), _createBlock("div", _hoisted_16, [
                    _createVNode("img", {
                      class: "team__blurImage",
                      src: _ctx.team.picture
                    }, null, 8, ["src"]),
                    _createVNode("img", {
                      class: "team__mainImage",
                      src: _ctx.team.picture
                    }, null, 8, ["src"]),
                    _createVNode("i", {
                      class: ["team__image_toggle button button--action button--inverted", {
                              'icon-cancel': _ctx.teamImageVisible
                            }],
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleTeamImage && _ctx.toggleTeamImage(...args)))
                    }, null, 2)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", {
                  class: ["item__title tab__item", {'tab__item--selected': _ctx.tabSelected === _ctx.TAB_TYPES.SCHEDULE}],
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleSchedule && _ctx.toggleSchedule(...args)))
                }, [
                  _hoisted_18,
                  _hoisted_19
                ], 2),
                _createVNode("div", {
                  class: ["item__title tab__item", {'tab__item--selected': _ctx.tabSelected === _ctx.TAB_TYPES.PLAYERS}],
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.togglePlayers && _ctx.togglePlayers(...args)))
                }, [
                  _hoisted_20,
                  _hoisted_21
                ], 2),
                _createVNode("div", {
                  class: ["item__title tab__item tab--social", {'tab__item--selected': _ctx.tabSelected === _ctx.TAB_TYPES.SOCIAL}],
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleSocial && _ctx.toggleSocial(...args)))
                }, [
                  _hoisted_22,
                  _hoisted_23
                ], 2)
              ]),
              _createVNode("div", _hoisted_24, [
                (_ctx.tabSelected === _ctx.TAB_TYPES.SCHEDULE)
                  ? (_openBlock(), _createBlock(_component_TheScheduleTable, {
                      key: 0,
                      filterSetName: _ctx.filterSetName,
                      canFilter: false,
                      splitByWeek: false
                    }, null, 8, ["filterSetName"]))
                  : (_ctx.tabSelected === _ctx.TAB_TYPES.PLAYERS)
                    ? (_openBlock(), _createBlock(_component_TheTeamPlayers, {
                        key: 1,
                        teamName: _ctx.team.name,
                        class: "team__players"
                      }, null, 8, ["teamName"]))
                    : (_ctx.tabSelected === _ctx.TAB_TYPES.SOCIAL)
                      ? (_openBlock(), _createBlock("img", {
                          key: 2,
                          class: "item team__social",
                          src: _ctx.team.picture
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true)
              ])
            ])
          ]))
    ])
  ]))
})